<!--产品定制-我的图库-->
<template>
  <div>
    <el-aside
      v-if="user.userType !== '00'"
      style="width: 215px; overflow: hidden; float: left"
    >
      <ul v-if="showMenu" class="left_url_tab">
        <div class="menu">
          <div class="title">{{ menuTitle }}</div>
          <el-tree
            :data="typeIdTree"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </ul>
      <!--商品滚动播放-->
      <Broadcast></Broadcast>
    </el-aside>

    <div
      :style="{ marginLeft: user.userType != '00' ? 246 : 0 }"
      class="image-store"
    >
      <Breadcrumb></Breadcrumb>
      <div class="common-limit line-height-40">
        <div class="form-body">
          <el-form
            ref="form"
            :model="queryParams"
            label-width="80px"
            size="small"
          >
            <el-row style="overflow: hidden" :gutter="24">
              <el-col v-if="user.userType == '00'" :span="8">
                <el-form-item label="主账号：" prop="createTime">
                  <template>
                    <el-select
                      clearable
                      size="small"
                      v-model="queryParams.pOperNo"
                      filterable
                    >
                      <template v-for="(value, key) in userAccountList">
                        <el-option
                          :key="value.userName"
                          :label="
                            `${value.userName}${
                              value.nickName ? '(' + value.nickName + ')  ' : ''
                            }`
                          "
                          :value="value.userName"
                        ></el-option>
                      </template>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>

              <el-col v-if="user.userType == '00'" :span="8">
                <el-form-item label="子账号：" prop="operNo">
                  <el-input v-model="queryParams.operNo" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片名称：" prop="picName">
                  <el-input v-model="queryParams.picName" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片形式：" prop="mapShape">
                  <el-select clearable v-model="queryParams.mapShape">
                    <template v-for="(value, key) in dictData['map_shape']">
                      <el-option
                        :key="value.value"
                        :label="value.label"
                        :value="value.value"
                      ></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片格式：" prop="mapFormat">
                  <el-input v-model="queryParams.mapFormat" clearable />
                </el-form-item>
              </el-col>
              <el-col v-if="user.userType == '00'" :span="8">
                <el-form-item label="是否删除：" prop="picName">
                  <el-select clearable v-model="queryParams.delFlag">
                    <el-option :label="`正常`" :value="`1`"></el-option>
                    <el-option :label="`删除`" :value="`0`"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="图片编号：" prop="mapId">
                  <el-input v-model="queryParams.mapId" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="(isImageOrder ? '出单时间' : '上传时间') + '：'"
                  prop="time"
                >
                  <el-date-picker
                    v-model="queryParams.time"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col v-if="isImageOrder" :span="8">
                <el-form-item label="店铺名称：" class="item">
                  <el-select
                    clearable
                    v-model="queryParams.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopName"
                      :value="item.shopId"
                      >{{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="图片属性：" prop="mapAttr">
                  <el-select clearable v-model="queryParams.mapAttr">
                    <el-option :label="`印花`" :value="`01`"></el-option>
                    <el-option :label="`刺绣`" :value="`02`"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col
                style="text-align: right"
                l
                :span="isImageOrder ? 16 : 24"
              >
                <el-form-item label="" class="item">
                  <el-button type="primary" size="small" @click="loadData"
                    >搜索</el-button
                  >
                  <el-button size="small" @click="resetForm">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="table-body">
        <div class="table-menu" style="overflow: hidden">
          <span v-if="!isImageOrder" style="float: left">
            <el-button
              v-if="
                user.userType === '00' ||
                  (user.userType !== '00' && menuTitle == '我的图库')
              "
              size="small"
              @click="jumpToBin"
              >回收站 <i class="el-icon-delete"></i
            ></el-button>

            <el-dropdown
              v-if="
                user.userType === '00' ||
                  (user.userType !== '00' && menuTitle == '我的图库')
              "
              @command="handleCommand"
              style="margin: 0 12px"
            >
              <el-button size="small" type="primary">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="name">批量设置名称</el-dropdown-item>
                <el-dropdown-item command="class"
                  >批量设置分类</el-dropdown-item
                >
                <el-dropdown-item command="delete">批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              size="small"
              type="success"
              v-if="
                user.userType === '00' ||
                  (user.userType !== '00' && menuTitle == '我的图库')
              "
              @click="showClassification"
              >分类管理</el-button
            >
            <el-button
              v-if="
                user.userType === '00' ||
                  (user.userType !== '00' && menuTitle == '我的图库')
              "
              size="small"
              type="error"
              @click="showUpload"
              >上传图片</el-button
            >
          </span>
          <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="loadData"
            :layout="'slot, total, sizes, prev, pager, next, jumper'"
          >
          </pagination>
        </div>
        <el-table
          v-show="
            user.userType === '00' ||
              (user.userType !== '00' && menuTitle == '我的图库')
          "
          v-loading="loading"
          :data="tableData"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column width="186px" label="图片编号" prop="mapId">
            <template slot-scope="scope">
              <span
                @click="handleShowDetail(scope.row.mapId)"
                style="color: #409eff; cursor: pointer"
                >{{ scope.row.mapId }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <el-col style="width: 300px">
                <el-popover
                  placement="right"
                  trigger="hover"
                  :close-delay="closeDelay"
                >
                  <img
                    class="img-big"
                    width="300px"
                    height="300px"
                    :src="
                      scope.row.picUrl3 ? scope.row.picUrl3 : scope.row.picUrl
                    "
                  />
                  <img
                    slot="reference"
                    class="img-big"
                    width="100px"
                    height="100px"
                    :src="
                      scope.row.picUrl2 ? scope.row.picUrl2 : scope.row.picUrl
                    "
                  />
                </el-popover>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column label="图片名称">
            <template slot-scope="scope">
              <el-row
                type="flex"
                justify="space-between"
                style="height: 40px; line-height: 40px"
              >
                <div>
                  {{ scope.row.picName }}
                </div>
                <div
                  v-if="
                    (user.userType === '00' ||
                      (user.userType !== '00' && menuTitle == '我的图库')) &&
                      menuTitle != '出单图库' &&
                      menuTitle != '共享图库'
                  "
                >
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click="
                      fileDetailInfo = Object.assign(fileDetailInfo, scope.row)
                      fileNameVisible = true
                    "
                  ></el-button>
                </div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="图片属性">
            <template slot-scope="scope">
              <span>{{
                scope.row.mapAttr == "01" || !scope.row.mapAttr
                  ? "印花"
                  : "刺绣"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图片规格">
            <template slot-scope="scope">
              <div>
                尺寸：{{ scope.row.picWidth }} x {{ scope.row.picHeight }}
              </div>
              <div>
                形状：{{
                  scope.row.mapShape
                    ? dictMap["map_shape"][scope.row.mapShape]
                    : ""
                }}
              </div>
              <div>格式：{{ scope.row.mapFormat }}</div>
              <div>大小：{{ scope.row.fileSize }}</div>
            </template>
          </el-table-column>
          <el-table-column label="图片分类">
            <template slot-scope="scope">
              <span>{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出单数" prop="orderNum">
            <template slot-scope="scope">
              <div
                @click="handleShowMapOrders(scope.row)"
                style="color: #409eff; cursor: pointer"
              >
                {{ scope.row.orderNum ? scope.row.orderNum : "0" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.userType == '00'"
            label="状态"
            prop="orderNum"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.delFlag == "1" ? "正常" : "删除" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.userType == '00'"
            label="主账号"
            prop="orderNum"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.pOperNo }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="上传者" prop="operNo"></el-table-column>
          <el-table-column
            width="160"
            label="上传时间"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            prop="handel"
            label="操作"
            align="center"
            width="150"
            v-if="!isImageOrder"
          >
            <template slot-scope="scope">
              <p>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleShowClassFromTable(scope.row)"
                  >更改分类
                </el-button>
              </p>
              <p v-if="user.userType !== '00'">
                <el-button
                  type="text"
                  size="mini"
                  @click="handleShare(scope.row)"
                  >指定分享
                </el-button>
              </p>
              <p>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleDeleteMap(scope.row)"
                  >删除
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-show="
            !(
              user.userType === '00' ||
              (user.userType !== '00' && menuTitle == '我的图库')
            )
          "
          v-loading="loading"
          :data="tableData"
        >
          <el-table-column width="186px" label="图片编号" prop="mapId">
            <template slot-scope="scope">
              <span
                @click="handleShowDetail(scope.row.mapId)"
                style="color: #409eff; cursor: pointer"
                >{{ scope.row.mapId }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <el-col style="width: 300px">
                <el-popover
                  placement="right"
                  trigger="hover"
                  :close-delay="closeDelay"
                >
                  <img
                    class="img-big"
                    width="300px"
                    height="300px"
                    :src="
                      scope.row.picUrl3 ? scope.row.picUrl3 : scope.row.picUrl
                    "
                  />
                  <img
                    slot="reference"
                    class="img-big"
                    width="100px"
                    height="100px"
                    :src="
                      scope.row.picUrl2 ? scope.row.picUrl2 : scope.row.picUrl
                    "
                  />
                </el-popover>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column label="图片名称">
            <template slot-scope="scope">
              <el-row
                type="flex"
                justify="space-between"
                style="height: 40px; line-height: 40px"
              >
                <div>
                  {{ scope.row.picName }}
                </div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="图片规格">
            <template slot-scope="scope">
              <div>
                尺寸：{{ scope.row.picWidth }} x {{ scope.row.picHeight }}
              </div>
              <div>
                形状：{{
                  scope.row.mapShape
                    ? dictMap["map_shape"][scope.row.mapShape]
                    : ""
                }}
              </div>
              <div>格式：{{ scope.row.mapFormat }}</div>
              <div>大小：{{ scope.row.fileSize }}</div>
            </template>
          </el-table-column>
          <el-table-column label="图片分类">
            <template slot-scope="scope">
              <span>{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出单数" prop="orderNum">
            <template slot-scope="scope">
              <div
                @click="handleShowMapOrders(scope.row)"
                style="color: #409eff; cursor: pointer"
              >
                {{ scope.row.orderNum ? scope.row.orderNum : "0" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="isImageOrder ? '出单时间' : '上传时间'"
            prop="createTime"
          ></el-table-column>
        </el-table>
        <pagination
          class="bottom-sticky"
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
        />
      </div>

      <el-dialog
        :close-on-click-modal="false"
        title="更改分类"
        :visible.sync="changeClassVisible"
        destroy-on-close
        width="30%"
      >
        <div>
          <el-form
            ref="changeClassForm"
            :model="changeClassForm"
            :rules="changeClassRules"
            label-width="100px"
            size="small"
          >
            <el-form-item label="图片分类：" prop="typeId">
              <TreeSelect
                :props="treeSelectProps"
                :options="typeIdSelect"
                v-model="changeClassForm.typeId"
                ref="childSelTree"
                style="width: 100%"
              ></TreeSelect>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="changeClassVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="changeClass" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="指定分享"
        :visible.sync="shareVisible"
        destroy-on-close
        width="30%"
      >
        <div>
          <div class="hint">
            <i class="el-icon-error-outline" style="margin: 0 4px 0 0"></i
            >分享后不可撤回，将加入到对方的图库里
          </div>
          <el-form
            ref="shareForm"
            :model="shareForm"
            :rules="shareRules"
            label-width="100px"
            size="small"
          >
            <el-form-item label="选择账号：" prop="shareNo">
              <el-select multiple v-model="shareForm.shareNo">
                <el-option
                  v-for="(record, index) in accountList"
                  :key="index"
                  :label="record.userName"
                  :value="record.userName"
                  >{{ record.userName }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="shareVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="handleShareMap" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="配置分类"
        :visible.sync="classificationVisible"
        destroy-on-close
        width="800px"
      >
        <ImgClassification
          :type="queryParams.mapSource"
          :visible="classificationVisible"
          @close="closeImgClassification"
        ></ImgClassification>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="出单数"
        :visible.sync="mapOrdersVisible"
        destroy-on-close
        width="40%"
      >
        <el-table :data="mapOrdersData">
          <el-table-column label="订单号" prop="appNo"></el-table-column>
          <el-table-column label="创建时间" prop="createTime"></el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="上传图片"
        :visible.sync="uploadVisible"
        destroy-on-close
        width="1080px"
        style="height: 80vh"
      >
        <div>
          <el-form
            ref="uploadForm"
            :model="uploadForm"
            :rules="uploadRules"
            label-width="100px"
            size="small"
          >
            <el-form-item label="图片分类：" prop="typeId">
              <TreeSelect
                :props="treeSelectProps"
                :options="typeIdSelect"
                v-model="uploadForm.typeId"
                ref="childSelTree"
                style="width: 100%"
              ></TreeSelect>
            </el-form-item>
            <el-form-item label="图片属性：" prop="mapAttr">
              <el-radio-group v-model="uploadForm.mapAttr">
                <template v-for="(value, key) in dictData['MAP_ATTR']">
                  <el-radio :label="value.value" :key="value.value">
                    {{ value.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="图片选择：">
              <el-upload
                ref="upload"
                drag
                action="#"
                :file-list="fileList"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="handleChange"
                :multiple="true"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  支持一次传多张图片，图片大小限制20M
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="isAgree"
                >上传图片或/和文字时不得存在涉政、涉黄、侵权等违法行为，情节严重的将予以封号处理，感谢您的配合。我已经阅读并同意此协议。</el-checkbox
              >
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="uploadVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="saveImage" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        width="937px"
        title="图片详情"
        :visible.sync="detailVisible"
        destroy-on-close
      >
        <div class="map-detail">
          <div style="float: left; margin: 0 16px 0 0">
            <img
              style="width: 230px; height: 230px"
              :src="
                `${detail.picUrl}?x-oss-process=image/resize,m_fill,h_230,w_230`
              "
            />
          </div>
          <div style="float: left; width: 300px">
            <div class="line">图片编号：{{ detail.mapId }}</div>
            <div class="line">图片名称：{{ detail.picName }}</div>
            <div class="line">
              尺寸：{{ detail.picWidth }}px x {{ detail.picHeight }}px
            </div>
            <div class="line">格式：{{ detail.mapFormat }}</div>
            <div class="line">出单数：{{ detail.orderNum }}单</div>
            <div
              v-if="
                user.userType === '00' ||
                  (user.userType !== '00' &&
                    menuTitle == '我的图库' &&
                    menuTitle != '出单图库' &&
                    menuTitle != '共享图库')
              "
              class="line"
            >
              <el-button
                size="mini"
                @click="handleDeleteMap(detail)"
                type="danger"
                >删除</el-button
              >
            </div>
          </div>
          <div style="float: left; width: 300px">
            <div class="line">图片分类：{{ detail.typeName }}</div>
            <div class="line">上传时间：{{ detail.createTime }}</div>
            <div class="line">
              形状：{{ dictMap["map_shape"][detail.mapShape] }}
            </div>
            <div class="line">大小：{{ detail.fileSize }}</div>
            <div class="line">产品数：{{ detail.proNum }}款</div>
          </div>
        </div>
        <div
          v-if="designList && designList.length > 0"
          class="el-dialog__header"
          style="border-radius: 10px"
        >
          <span class="el-dialog__title">已设计产品</span>
        </div>
        <div style="overflow: hidden; margin: 16px 0 0 0">
          <div
            v-for="(record, index) in designList"
            :key="index"
            class="design-item"
          >
            <div>
              <img
                @click="handleOpenDesign(record.designId)"
                :src="
                  `${record.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                "
              />
            </div>
            <div style="">
              <div class="index-goods-detail pt13">
                <div class="index-goods-tit shop_tit_style">
                  {{ record.designProName }}
                </div>
                <div class="index-goods-price">
                  <span class="zc">￥{{ record.price }}</span>
                </div>
                <div class="mt5 shop_newTime_style">
                  设计时间：{{ formatDate(record.createTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <pagination
          v-show="total1 > 0"
          :total="total1"
          :page.sync="designForm.pageNum"
          :limit.sync="designForm.pageSize"
          @pagination="getDesignList"
          :layout="`prev, pager, next, jumper, total`"
        />
        <div slot="footer">
          <el-button type="primary" @click="handleCloseDetail" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        :close-on-click-modal="false"
        title="更新文件名"
        :visible.sync="fileNameVisible"
        destroy-on-close
        width="30%"
      >
        <div>
          <el-form
            ref="fileNameform"
            :model="fileDetailInfo"
            :rules="fileDetailInfoRules"
            label-width="80px"
          >
            <el-form-item label="文件名" prop="picName">
              <el-input v-model="fileDetailInfo.picName"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button @click="fileNameVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="updateFileName()" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import TreeSelect from "@/components/common/treeSelect"
import ImgClassification from "./imgClassification"
import { getMapInfo } from "@/api/map/map"
import Broadcast from "@/components/common/Broadcast"
import { getShopList } from "@/api/system/shopManage"
import {
  listImgMap,
  listImgMapType,
  getImgMapTypeTree,
  addImgMap,
  editImgMap,
  getImgMapTypeSelect,
  deleteImgMap,
  listShare,
  listOrder,
  addShare,
  getShareTree,
  listMap,
  listDesign,
  listChild,
  listChildTree,
  updateName,
} from "@/api/customProduct/imageStore"
import { uploadFile } from "@/api/upload/upload"
import { listShareChild } from "@/api/system/user"
import moment from "moment"
import { listUser } from "@/api/business/merchantManage"

export default {
  name: "imageStore",
  components: { Breadcrumb, TreeSelect, ImgClassification, Broadcast },
  data() {
    return {
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      }, // 图片分类
      typeIdTree: [],
      typeIdSelect: [],
      queryParams: {
        mapSource: "02",
        mapShape: undefined,
        mapFormat: undefined,
        yesOrNo: undefined,
        typeId: undefined,
        time: [],
        mapId: undefined,
        picName: undefined,
        beginTime: undefined,
        endTime: undefined,
        delFlag: "",
        shopId: "",
        pageSize: 30,
        pageNum: 1,
        pOperNo: "",
        operNo: "",
        mapAttr: "",
      },
      designForm: { mapId: "", pageNum: 1, pageSize: 8 },
      total1: 0,
      loading: false,
      total: 0,
      tableData: [],
      checkList: [], //选中的图片
      showMenu: true,
      // 上传文件
      uploadVisible: false,
      uploadForm: {
        typeId: undefined,
        mapAttr: "01",
      },
      fileList: [],
      uploadFlag: false,
      uploadRules: {
        typeId: [
          { required: true, message: "请选择图片分类", trigger: "blur" },
        ],
      },
      //图片详情
      detail: {},
      detailVisible: false,
      mapOrdersVisible: false,
      mapOrdersData: [],
      designList: [],
      // 分类管理
      classificationVisible: false,
      // 更换分类
      changeClassVisible: false,
      changeClassForm: {
        typeId: undefined,
        mapId: undefined,
      },
      changeClassRules: {
        typeId: [
          { required: true, message: "请选择图片分类", trigger: "blur" },
        ],
      },
      shareForm: {
        mapId: "",
        shareNo: [],
      },
      shareRules: {
        shareNo: [{ required: true, message: "请选择账号", trigger: "blur" }],
      },
      isCheckAll: false,
      isIndeterminate: false,
      closeDelay: 0,
      // 修改文件名称
      fileNameVisible: false,
      fileDetailInfo: {
        picName: undefined,
      },
      fileDetailInfoRules: {
        picName: [
          { required: true, message: "请输入文件名称！", trigger: "blur" },
        ],
      },
      defaultProps: {
        value: "typeId",
        label: "typeName",
        children: "childrenTree",
      },
      menuTitle: "我的图库",
      mapObject: "",
      shareVisible: false,
      accountList: [],
      shopList: [],
      isAgree: true,
      scrollMenu: null,
      objectHeight: null,
      userAccountList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx", "roles", "user"]),
    routeName() {
      return this.$route.path
    },
    isImageOrder() {
      if (this.routeName.indexOf("imageOrder") > -1) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
    // let curDate = new Date()
    // let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    // this.queryParams.time = [
    //   this.parseTime(preDate, "{y}-{m}-{d}"),
    //   this.parseTime(curDate, "{y}-{m}-{d}"),
    // ]
    this.loadData(true)
    this.getShopList()
    this.$nextTick(() => {
      this.scrollMenu = document.querySelector(".table-menu")
      this.objectHeight = this.scrollMenu.offsetTop
      window.addEventListener("scroll", this.handleScroll)
    })

    this.getAccountList()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  watch: {
    checkList() {
      if (this.checkList.length == 0) {
        this.isCheckAll = false
      }
    },
    routeName() {
      this.resetForm()
      this.loadData(true)
    },
    async shareVisible() {
      if (this.shareVisible) {
        let result = await listShareChild()
        let arrays = []
        for (let record of result.rows) {
          if (record.userName != this.user.name) {
            arrays.push(record)
          }
        }
        this.accountList = arrays
      }
    },
    classificationVisible() {
      if (!this.classificationVisible) {
        this.loadData(true)
      }
    },
  },
  methods: {
    handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      console.log(scrollHeight + "," + this.objectHeight)
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 312px)"
        menu.style.padding = "8px 0"
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = "0"
      }
    },
    async getAccountList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.userAccountList = result.rows
    },
    async handleShowMapOrders(row) {
      let result = await listMap({ mapId: row.mapId })
      this.mapOrdersData = result.rows
      this.mapOrdersVisible = true
    },
    handleNodeClick(data) {
      if (this.routeName.indexOf("imageCommon") == -1) {
        this.queryParams.typeId = data.typeId
        this.queryParams.operNo = data.operNo
        this.queryParams.pOperNo = data.pOperNo
      } else {
        this.queryParams.typeId = data.typeId
      }
      this.loadData()
    },
    handleCloseDetail() {
      this.detailVisible = false
    },
    async handleShowDetail(id) {
      let result = await getMapInfo(id)
      this.detail = result.data
      this.designForm.mapId = id
      this.getDesignList()
      this.detailVisible = true
    },
    async getDesignList() {
      let response = await listDesign(this.designForm)
      this.total1 = response.total
      this.designList = response.rows
    },
    getTreeNodeId(val) {
      this.queryParams.typeId = val
    },
    handleOpenDesign(designId) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { designId: designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    async getImgMapTypeTree(type) {
      const { data } = await getImgMapTypeTree({ type, mapAttr: this.queryParams.mapAttr })
      if (data.length > 0) {
        data[0].imgNum = this.total
      }
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
      }
      this.typeIdTree = data
    },
    async getImgMapTypeSelect(type) {
      let result = await getImgMapTypeSelect({ type })
      let treeData = result.data
      if (treeData.length > 0) {
        treeData[0].imgNum = this.total
      }
      if (treeData) {
        treeData.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
      }
      this.typeIdSelect = treeData
    },
    /**查询分类树 */
    async getImgShareTree() {
      const { data } = await getShareTree()
      if (data.length > 0) {
        data[0].imgNum = this.total
      }
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
        this.typeIdTree = data
      }
    },
    /**查询分类树 */
    async getImgSubTree() {
      const { data } = await listChildTree()
      if (data.length > 0) {
        data[0].imgNum = this.total
      }
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
        this.typeIdTree = data
      }
    },
    handleShare(row) {
      this.shareForm.shareNo = []
      this.shareForm.mapId = row.mapId
      this.shareVisible = true
    },
    handleShareMap() {
      this.$refs["shareForm"].validate(async (valid) => {
        if (valid) {
          let shareForm = this._.clone(this.shareForm)
          shareForm.shareNo = shareForm.shareNo.join(",")
          await addShare(shareForm)
          this.$message.success("成功！")
          this.shareVisible = false
          this.loadData()
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    loadData(loadMenu) {
      let _self = this
      this.startLoading()
      if (_self.queryParams.time) {
        _self.queryParams.beginTime = _self.queryParams.time[0]
        _self.queryParams.endTime = _self.queryParams.time[1]
      } else {
        _self.queryParams.beginTime = undefined
        _self.queryParams.endTime = undefined
      }
      let params = Object.assign({}, _self.queryParams)
      delete params["time"]

      let loadMethod = listImgMap
      if (this.routeName.indexOf("imageShare") > -1) {
        params.mapSource = "02"
        _self.queryParams.mapSource = "02"
        loadMethod = listShare
        this.menuTitle = "共享图库"
        this.showMenu = true
      } else if (this.routeName.indexOf("imageOrder") > -1) {
        params.mapSource = undefined
        _self.queryParams.mapSource = undefined
        loadMethod = listOrder
        this.menuTitle = "出单图库"
        this.showMenu = false
      } else if (this.routeName.indexOf("imageMe") > -1) {
        params.mapSource = "02"
        _self.queryParams.mapSource = "02"
        this.menuTitle = "我的图库"
        this.showMenu = true
      } else if (this.routeName.indexOf("imageSub") > -1) {
        loadMethod = listChild
        this.menuTitle = "子账号图库"
        this.showMenu = true
      } else if (
        this.routeName.indexOf("imageCommon") > -1 ||
        this.routeName.indexOf("mapmng") > -1
      ) {
        params.mapSource = "01"
        _self.queryParams.mapSource = "01"
        this.menuTitle = "公共图库"
        this.showMenu = true
      }

      if (this.user.userType !== "00") {
        params.delFlag = "1"
      }

      loadMethod(params)
        .then((res) => {
          _self.total = res.total
          _self.tableData = res.rows

          if (this.routeName.indexOf("imageShare") > -1) {
            loadMenu ? this.getImgShareTree() : ""
          } else if (this.routeName.indexOf("imageMe") > -1) {
            loadMenu ? this.getImgMapTypeTree("02") : ""
          } else if (this.routeName.indexOf("imageSub") > -1) {
            loadMenu ? this.getImgSubTree() : ""
          } else if (
            this.routeName.indexOf("imageCommon") > -1 ||
            this.routeName.indexOf("mapmng") > -1
          ) {
            loadMenu ? this.getImgMapTypeTree("01") : ""
          }
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },

    resetForm() {
      this.queryParams.shopId = ""
      this.queryParams.typeId = ""
      this.queryParams.operNo = ""
      this.queryParams.pOperNo = ""
      this.$refs["form"].resetFields()
    },
    handleChange(file, fileList) {
      this.fileList = fileList
      var reader = new FileReader()
      let _this = this
      reader.onload = function(event) {
        var txt = event.target.result
        var img = document.createElement("img")
        img.src = txt
        img.onload = function() {
          _this.fileList.map((record) => {
            if (record.uid === file.uid) {
              record.picWidth = img.width
              record.picHeight = img.height
            }
          })
        }
      }
      reader.readAsDataURL(file.raw)
    },
    // 保存文件
    async saveImage() {
      let _self = this

      let imageDataArr = []
      if (!_self.uploadForm.typeId) {
        _self.$message.error("请选择图片分类！")
        return
      }

      if (!this.isAgree) {
        _self.$message.error("请先阅读并同意此协议！")
        return
      }
      let isSuccess = true
      this.startLoading()
      try {
        if (_self.fileList.length > 0) {
          for (let i = 0; i < _self.fileList.length; i++) {
            const file = _self.fileList[i]
            if (file.raw) {
              let imageData = Object.assign({}, _self.uploadForm)
              if (true) {
                const isLt2M = file.size / 1024 / 1024 < 20
                if (!isLt2M) {
                  // isSuccess = false;
                  _self.msgError(`${file.name}超过20M，上传失败！`)
                  continue
                }
                const { uploadFlag, fileUrl } = await uploadFile(file, true)
                if (!uploadFlag) {
                  _self.msgError("上传失败！")
                  this.endLoading()
                  return
                }

                imageData.picUrl = fileUrl
                // imageData.mapFormat = file.raw.type
                imageData.picWidth = file.picWidth
                imageData.picHeight = file.picHeight
                imageData.picName = file.raw.name
                imageData.fileSize = file.raw.size
              }

              //上传低清图片
              if (file.picWidth > 150) {
                const img = await this.readImg(file.raw)
                const blob = await this.compressImg(
                  img,
                  file.type,
                  150,
                  (150 * imageData.picHeight) / imageData.picWidth
                )
                var { uploadFlag, fileUrl } = await uploadFile(blob, true)
                if (!uploadFlag) {
                  _self.msgError("上传失败！")
                  this.endLoading()
                  return
                }
                imageData.picUrl2 = fileUrl
              } else {
                imageData.picUrl2 = imageData.picUrl
              }

              if (file.picWidth > 500) {
                const img = await this.readImg(file.raw)
                const blob = await this.compressImg(
                  img,
                  file.type,
                  500,
                  (500 * imageData.picHeight) / imageData.picWidth
                )
                var { uploadFlag, fileUrl } = await uploadFile(blob, true)
                if (!uploadFlag) {
                  _self.msgError("上传失败！")
                  this.endLoading()
                  return
                }
                imageData.picUrl3 = fileUrl
              } else {
                imageData.picUrl3 = imageData.picUrl
              }
              imageDataArr.push(imageData)
            }
          }
          if (imageDataArr.length > 0) {
            await addImgMap(imageDataArr)
              .then((res) => {
                if (res.code === 200) {
                  _self.msgSuccess("上传成功！")
                  _self.uploadVisible = false
                  _self.fileList = []
                  this.loadData()
                  this.endLoading()
                } else {
                  _self.msgError("上传失败！")
                  this.endLoading()
                }
              })
              .catch((err) => {
                console.error(err)
                this.endLoading()
              })
          }
          this.endLoading()
        } else {
          _self.$message.error("请选择上传的图片！")
          this.endLoading()
        }
      } catch (error) {
        this.endLoading()
      }
    },
    showClassification() {
      this.classificationVisible = true
    },
    showUpload() {
      this.uploadForm.mapAttr = "01"
      this.uploadVisible = true
      this.getImgMapTypeSelect(this.queryParams.mapSource)
    },
    handleShowClass() {},
    handleShowClassFromTable(mapObject) {
      this.mapObject = this._.clone(mapObject)
      this.changeClassForm.typeId = ""
      this.getImgMapTypeSelect(this.queryParams.mapSource)
      this.changeClassVisible = true
    },

    /**更改分类 */
    changeClass() {
      let _self = this
      this.$refs["changeClassForm"].validate(async (valid) => {
        if (valid) {
          if (this.mapObject) {
            _self.changeClassForm.mapId = this.mapObject.mapId
            await editImgMap(_self.changeClassForm)
          } else {
            for (let index = 0; index < _self.checkList.length; index++) {
              const element = _self.checkList[index]
              let params = Object.assign({}, element)
              _self.changeClassForm.mapId = params.mapId
              await editImgMap(_self.changeClassForm)
            }
          }

          _self.$message.success("成功！")
          _self.fileNameVisible = false
          _self.loadData()
          _self.getImgMapTypeTree()
          _self.changeClassVisible = false
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**删除图片 */
    batchRemoveImg() {
      let _self = this
      let ids = []
      _self.checkList.forEach((item) => {
        ids.push(item.mapId)
      })
      _self.$XModal
        .confirm("您确定要删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then(async (type) => {
          if (type == "confirm") {
            for (let index = 0; index < ids.length; index++) {
              let params = Object.assign({}, { mapId: ids[index] })
              params.delFlag = "0"
              await editImgMap(params)
            }
            _self.$message.success("删除成功！")
            _self.fileNameVisible = false
            _self.loadData()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editName() {},
    async handleDeleteMap(detail) {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(async () => {
          detail.delFlag = "0"
          await editImgMap(this._.pick(detail, "delFlag", "mapId"))
          this.$message.success("删除成功！")
          this.detailVisible = false
          this.loadData()
        })
        .catch(() => {})
    },
    /**更改文件名称 */
    updateFileName() {
      let _self = this
      let mapId = ""
      if (_self.fileDetailInfo.mapId) {
        mapId = _self.fileDetailInfo.mapId
      } else {
        let ids = []
        _self.checkList.forEach((item) => {
          ids.push(item.mapId)
        })
        mapId = ids.join(",")
      }
      updateName({
        mapId: mapId,
        picName: this.fileDetailInfo.picName,
      }).then((response) => {
        if (response.code == "200") {
          _self.$message.success("成功！")
          _self.fileNameVisible = false
          _self.loadData()
        } else {
          _self.$message.error("失败！")
        }
      })
    },

    //选中所有行
    checkAll(val) {
      this.isIndeterminate = false
      if (val) {
        this.$refs.imgStoreTab.toggleAllSelection()
      } else {
        this.$refs.imgStoreTab.clearSelection()
      }
    },
    //行勾选事件
    handleSelectionChange(val) {
      this.isIndeterminate =
        val.length > 0 && val.length < this.tableData.length
      this.isCheckAll = val.length === this.tableData.length
      this.checkList = val
    },
    append(data) {
      const newChild = { typeId: "asd", typeName: "new", childrenTree: [] }
      if (!data.childrenTree) {
        this.$set(data, "childrenTree", [])
      }
      data.childrenTree.push(newChild)
    },

    remove(node, data) {
      const parent = node.parent
      const children = parent.data.childrenTree || parent.data
      const index = children.findIndex((d) => d.typeId === data.typeId)
      children.splice(index, 1)
    },
    getShopList() {
      getShopList().then((res) => {
        this.shopList = res.rows
      })
    },
    turnWay(e) {
      var classVal = e.target.className
      if (classVal == "el-icon-caret-top") {
        e.target.setAttribute("class", "el-icon-caret-bottom")
        this.queryParams.byAsc = "desc"
      } else {
        e.target.setAttribute("class", "el-icon-caret-top")
        this.queryParams.byAsc = "asc"
      }
      this.loadData()
    },
    jumpToBin() {
      if (this.user.userType == "00") {
        this.$router.push({
          path: "/product_mng/manage/imgRecycleBin",
        })
      } else {
        this.$router.push({
          path: "/map/map_mng/imgRecycleBin",
        })
      }
    },
    handleCommand(command) {
      let _self = this
      let ids = []
      _self.checkList.forEach((item) => {
        ids.push(item.mapId)
      })
      if (ids.length == 0) {
        this.msgError("请选择需要操作的图片")
        return
      }

      if (command == "delete") {
        _self.$XModal
          .confirm("您确定要删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "再想想",
          })
          .then(async (type) => {
            if (type == "confirm") {
              for (let index = 0; index < ids.length; index++) {
                let params = Object.assign({}, { mapId: ids[index] })
                params.delFlag = "0"
                await editImgMap(params)
              }
              _self.$message.success("删除成功！")
              _self.fileNameVisible = false
              _self.loadData()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else if (command == "class") {
        this.mapObject = ""
        this.changeClassForm.typeId = ""
        this.getImgMapTypeSelect(this.queryParams.mapSource)
        this.changeClassVisible = true
      } else if (command == "name") {
        this.fileDetailInfo = { picName: "" }
        this.fileNameVisible = true
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!")
      }
      return isLt2M
    },
    closeImgClassification() {
      this.classificationVisible = false
    },
    // 压缩前将file转换成img对象
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function(e) {
          img.src = e.target.result
        }
        reader.onerror = function(e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function() {
          resolve(img)
        }
        img.onerror = function(e) {
          reject(e)
        }
      })
    },
    compressImg(img, type, mx, mh) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        const { width: originWidth, height: originHeight } = img
        // 最大尺寸限制
        const maxWidth = mx
        const maxHeight = mh
        // 目标尺寸
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            // 宽图片
            targetWidth = maxWidth
            targetHeight = Math.round(maxWidth * (originHeight / originWidth))
          } else {
            // 高图片
            targetHeight = maxHeight
            targetWidth = Math.round(maxHeight * (originWidth / originHeight))
          }
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function(blob) {
          resolve(blob)
        }, type || "image/png")
      })
    },
    formatDate(origin) {
      return moment(origin).format("yyyy-MM-DD")
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}
.btn-bar-right {
  text-align: right;
}
.map-detail {
  overflow: hidden;
  .line {
    line-height: 36px;
  }
}
.design-item {
  float: left;
  position: relative;
  display: block;
  text-align: center;
  background: #fff;
  border: 1px solid #e9e9e9;
  margin: 0 10px 24px 10px;
  padding: 0 0 12px 0;
  cursor: pointer;
  img {
    width: 200px;
    height: 200px;
  }
}
.design-item:hover {
  cursor: pointer;
  color: #000 !important;
  box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
  border: 1px solid #dddddd !important;
}

.image-store {
  display: block;
  margin: 0 0 0 246px;
}
.title {
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
  padding: 8px;
}
.left_url_tab {
  margin: 12px 0 0 0;
}
.image-store ::v-deep .el-row::after,
.image-store ::v-deep .el-row::before {
  display: inline-block;
}
.left_url_tab
  ::v-deep
  .is-current
  > .el-tree-node__content
  > .el-tree-node__label {
  background: #409eff;
  padding: 0 4px;
  border-radius: 4px;
  color: #ffffff;
}
.left_url_tab ::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: inherit;
}
.hint {
  background: #fefbe5;
  line-height: 32px;
  margin: 0 0 8px 8px;
  padding: 0 0 0 8px;
}

.menu ::v-deep .el-tree {
  padding: 5px 0;
}

.menu ::v-deep .el-tree .el-tree-node__content {
  margin-bottom: 2px;
}
.good-item {
}

.index-goods-detail {
  line-height: 20px;
  color: #333333;
}

.el-dialog__header {
  margin: 12px 0 0 0;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
.form-body .el-col-8 {
  margin: 0px 0 12px 0;
}
</style>
